import { Box } from "@chakra-ui/layout"
import { Button, ButtonGroup } from "@chakra-ui/react"
import { useContasReceber } from "../contexts/ContasReceberProvider"

export function Pagination() {
  const { page, setPage, data, lastPage } = useContasReceber()
  const isFirstPage = page === 1
  const isLastPage = lastPage === page

  const MAX_PAGES = 5 // Número máximo de páginas visíveis antes de exibir o "..."

  const pages = Array.from({ length: lastPage }, (_, index) => index + 1)

  let visiblePages = pages

  if (pages.length > MAX_PAGES) {
    const firstVisiblePage = Math.max(page - Math.floor(MAX_PAGES / 2), 1)
    const lastVisiblePage = Math.min(firstVisiblePage + MAX_PAGES - 1, lastPage)

    visiblePages = pages.slice(firstVisiblePage - 1, lastVisiblePage)
  }

  const handlePrevPage = () => {
    setPage((oldValue) => oldValue - 1)
  }

  const handleNextPage = () => {
    setPage((oldValue) => oldValue + 1)
  }

  const handlePageClick = (newPage) => {
    setPage(newPage)
  }

  return (
    <Box>
      <ButtonGroup spacing="2">
        <Button
          disabled={isFirstPage}
          onClick={handlePrevPage}
          variant="outline"
          colorScheme="blue"
          size="sm"
        >
          Anterior
        </Button>

        {/* Exibindo os números das páginas */}
        {visiblePages.map((pageNumber, index) => (
          <Button
            size="sm"
            key={pageNumber}
            onClick={() => handlePageClick(pageNumber)}
            variant={pageNumber === page ? "solid" : "outline"}
            colorScheme="blue"
          >
            {pageNumber}
          </Button>
        ))}

        {visiblePages[visiblePages.length - 1] !== lastPage && (
          <Button size="sm" variant="outline" colorScheme="blue" isDisabled>
            ...
          </Button>
        )}

        <Button
          size="sm"
          disabled={isLastPage}
          onClick={handleNextPage}
          variant="outline"
          colorScheme="blue"
        >
          Próxima
        </Button>
      </ButtonGroup>
    </Box>
  )
}
